module.exports = __webpack_public_path__ + "img/6_70.80f294e6.png";